import { useQuery } from "@tanstack/react-query";
import { getHubRiseConnections } from "../../../api/QrOrderingApi";

export function useHubRiseConnections(userProfile) {
  return useQuery({
    queryKey: ["hubrise-connections", userProfile.user_id, userProfile.organisation_id],
    enabled: Boolean(userProfile.user_id),
    retry: false,
    staleTime: 0,
    queryFn: async () => (await getHubRiseConnections()).data,
  });
}
